
<div *ngIf="!definition" class="h-100 w-100 d-flex justify-content-center align-items-center">
    <div class="font-size-18 color-valyrianSteel" cvLocalizedText langSection="Pipeline_Configuration" langKey="Select_A_Metric">Select a metric</div>
</div>
<div *ngIf="definition" class="container" style="padding: 0px 24px;">
    <div class="row mt-3">
        <div class="col-6">
            <span cvLocalizedText langSection="Pipeline_Configuration" langKey="Name">Name</span>:
        </div>
        <div class="col-6 text-truncate" [attr.title]="definition?.MetricName">
            {{definition?.MetricName}}
        </div>
    </div>

    <div class="row mt-4">
        <div class="col-6">
            <span cvLocalizedText langSection="Pipeline_Configuration" langKey="Abbreviation">Abbreviation</span>:
        </div>
        <div class="col-6 text-truncate" [attr.title]="definition?.Abreviation">
            {{definition?.Abreviation}}
        </div>
    </div>

    <div class="row mt-4">
        <div class="col-6">
            <span cvLocalizedText langSection="Pipeline_Configuration" langKey="Category">Category</span>:
        </div>
        <div class="col-6 text-truncate" [attr.title]="definition?.Group">
            {{definition?.Group}}
        </div>
    </div>

    <hr class="my-2" />

    <div class="row mt-2">
        <div class="col-6">
            <span cvLocalizedText langSection="Common" langKey="Description">Description</span>:
        </div>
        <div class="col-6">
            {{definition?.MetricDescription}}
        </div>
    </div>

    <div class="row mt-4">
        <div class="col-6">
            <span cvLocalizedText langSection="Pipeline_Configuration" langKey="Status">Status</span>:
        </div>
        <div class="col-6" [ngClass]="{'color-redRyder': definition?.Status?.IsValid === false}" [ngSwitch]="definition?.Status?.IsValid">
            <span *ngSwitchCase="true" cvLocalizedText langSection="Pipeline_Configuration" langKey="Valid">Valid</span>
            <span *ngSwitchCase="false" cvLocalizedText langSection="Pipeline_Configuration" langKey="Invalid">Invalid</span>
            <span *ngSwitchDefault cvLocalizedText langSection="Pipeline_Configuration" langKey="Unknown">Unknown</span>
        </div>
    </div>
    <div class="row" *ngIf="definition?.Status.IsValid === false">
        <div class="col-6 offset-6">
            <button type="button" class="btn btn-secondary btn-sm" (click)="reactivateDefinition()" [disabled]="isReactivating">
                <span cvLocalizedText langSection="Pipeline_Configuration" langKey="Reactivate">Reactivate</span>
            </button>
        </div>
    </div>

    <div class="row mt-4">
        <div class="col-6">
            <span cvLocalizedText langSection="Pipeline_Configuration" langKey="Format_Type">Format Type</span>:
        </div>
        <div class="col-6" [ngSwitch]="definition?.NumericType">
            <span *ngSwitchCase="0" cvLocalizedText langSection="Metrics" langKey="Currency">Currency</span>
            <span *ngSwitchCase="1" cvLocalizedText langSection="Metrics" langKey="Number">Number</span>
            <span *ngSwitchCase="2" cvLocalizedText langSection="Metrics" langKey="Percent">Percent</span>
            <span *ngSwitchCase="3" cvLocalizedText langSection="Metrics" langKey="Time">Time</span>
        </div>
    </div>
    <div class="row mt-4" *ngIf="definition?.NumericType == 3">
        <div class="col-6">
            <span cvLocalizedText langSection="Pipeline_Configuration" langKey="Metric_Time_Format">Time Format</span>:
        </div>
        <div class="col-6" [ngSwitch]="definition?.TimeFormat">
            <span *ngSwitchCase="1" cvLocalizedText langSection="Pipeline_Configuration" langKey="Seconds">Seconds</span>
            <span *ngSwitchCase="2" cvLocalizedText langSection="Pipeline_Configuration" langKey="Minutes">Minutes</span>
            <span *ngSwitchCase="3" cvLocalizedText langSection="Pipeline_Configuration" langKey="Hours">Hours</span>
            <span *ngSwitchCase="4">HH:MM:SS</span>
            <span *ngSwitchCase="5">HH:MM:SS.SSS</span>
        </div>
    </div>
    <div class="row mt-4" *ngIf="definition?.NumericType == 0">
        <div class="col-6">
            <span cvLocalizedText langSection="Pipeline_Configuration" langKey="Metric_Currency_Format">Currency Format</span>:
        </div>
        <div class="col-6">
            <span>{{definition?.CurrencyFormat}}</span>
        </div>
    </div>

    <hr class="my-2"/>

    <div class="row">
        <div class="col-6">
            <span cvLocalizedText langSection="Metrics" langKey="Component_Type">Component Type</span>:
        </div>
        <div class="col-6" [ngSwitch]="definition?.Type">
            <span *ngSwitchCase="0" cvLocalizedText langSection="Pipeline_Configuration" langKey="Metric_Component_Type_Standard">Standard Metric</span>
            <span *ngSwitchCase="1" cvLocalizedText langSection="Pipeline_Configuration" langKey="Metric_Component_Type_Snapshot">Snapshot Metric</span>
            <span *ngSwitchCase="2" cvLocalizedText langSection="Pipeline_Configuration" langKey="Metric_Component_Type_Calculated">Calculated Metric</span>
            <span *ngSwitchCase="3" cvLocalizedText langSection="Pipeline_Configuration" langKey="Metric_Component_Type_Real_Time">Real-time Metric</span>
        </div>
    </div>

    <div class="row mt-4" *ngIf="definition?.Type == 0 || definition?.Type == 1">
        <div class="col-6">
            <span cvLocalizedText langSection="Pipeline_Configuration" langKey="Components">Components</span>:
        </div>
        <div class="col-6">
            {{definition?.Components?.length || 0}}
        </div>
    </div>

    <ng-container *ngIf="definition?.Type == 0 || definition?.Type == 1">
        <div class="row mt-3" *ngFor="let component of definition?.Components">
            <div class="col">
                <metric-component-preview class="mw-100" [component]="component" [metricType]="definition?.Type" [editable]="false"></metric-component-preview>
            </div>
        </div>
    </ng-container>

    <div class="row mt-3" *ngIf="definition?.Type == 2">
        <div class="col-6">
            <span cvLocalizedText langSection="Pipeline_Configuration" langKey="Metric_Formula">Metric Formula</span>:
        </div>
    </div>
    <div class="row mt-3" *ngIf="definition?.Type == 2">
        <div class="col">
            <textarea readonly rows="5" class="form-control" style="font-family: monospace;">{{definition?.CalculatedFormula}}</textarea>
        </div>
    </div>

    <hr class="my-2"/>

    <div class="row">
        <div class="col-6 text-nowrap">
            <span cvLocalizedText langSection="Pipeline_Configuration" langKey="Employee_Hierarchy_Label">Employee Hierarchy</span>:
        </div>
        <div class="col-6">
            {{definition?.EmpLevelMin != null && groupTypes?.emp?.[definition?.EmpLevelMin]?.GroupTypeName || "N/A"}}
        </div>
    </div>

    <div class="row mt-4">
        <div class="col-6 text-nowrap">
            <span cvLocalizedText langSection="Pipeline_Configuration" langKey="Recording_Hierarchy_Label">Recording Hierarchy</span>:
        </div>
        <div class="col-6">
            {{definition?.RecLevelMin != null && groupTypes?.rec?.[definition?.RecLevelMin]?.GroupTypeName || "N/A"}}
        </div>
    </div>

    <div class="row mt-4">
        <div class="col-6">
            <span cvLocalizedText langSection="Pipeline_Configuration" langKey="Metric_Visible_Selector">Visible in Selector</span>:
        </div>
        <div class="col-6" [ngSwitch]="definition?.ShowInSelector">
            <span *ngSwitchCase="true" cvLocalizedText langSection="Common" langKey="Yes">Yes</span>
            <span *ngSwitchCase="false" cvLocalizedText langSection="Common" langKey="No">No</span>
        </div>
    </div>

    <div class="row mt-4">
        <div class="col-6">
            <span cvLocalizedText langSection="Pipeline_Configuration" langKey="Direction">Direction</span>:
        </div>
        <div class="col-6" [ngSwitch]="definition?.Direction">
            <span *ngSwitchCase="0" cvLocalizedText langSection="Pipeline_Configuration" langKey="Metric_Direction_Down">Down</span>
            <span *ngSwitchCase="1" cvLocalizedText langSection="Pipeline_Configuration" langKey="Metric_Direction_Up">Up</span>
        </div>
    </div>

    <div class="row mt-4" *ngIf="definition?.Type == 0 || definition?.Type == 1">
        <div class="col-6">
            <span cvLocalizedText langSection="Pipeline_Configuration" langKey="Aggregation">Aggregation</span>:
        </div>
        <div class="col-6" [ngSwitch]="definition?.AggregationType">
            <span *ngSwitchCase="0" cvLocalizedText langSection="Pipeline_Configuration" langKey="Sum">Sum</span>
            <span *ngSwitchCase="1" cvLocalizedText langSection="Pipeline_Configuration" langKey="Min">Min</span>
            <span *ngSwitchCase="2" cvLocalizedText langSection="Pipeline_Configuration" langKey="Max">Max</span>
        </div>
    </div>

    <div class="row mt-4">
        <div class="col-6">
            <span cvLocalizedText langSection="Metrics" langKey="Assignments">Assignments</span>:
        </div>
        <div class="col-6" *ngIf="definition?.AssignAll">
            <span cvLocalizedText langSection="Common" langKey="All">All</span>
        </div>
    </div>

    <div class="row mt-3" *ngIf="definition?.AssignmentIDs.length > 0">
        <div class="col">
            <div class="d-inline-block position-relative" style="width: 32px; height: 32px;" *ngIf="assignmentGroupsLoading">
                <cv-loader class="d-block" [overlay]="false" size="small"></cv-loader>
            </div>
            {{groupTypes?.rec?.[definition?.Level]?.GroupTypeName}}
            <ul *ngIf="!assignmentGroupsLoading">
                <li *ngFor="let group of assignmentGroups; trackBy: trackAssignmentGroups">
                    {{group.GroupName}}
                </li>
            </ul>
        </div>
    </div>

    <div class="mb-3" style="height: 1px;"><!-- Empty Spacer. Chrome only applies padding if it has a height --></div>

</div>
